import { NgModule }            from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from '@angular/common';
import { FooterComponent } from "./footer/footer-component";
import { HeaderComponent }   from './header/header-component';
import {TranslateModule} from "../../translate-module";
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
    imports : [
        ReactiveFormsModule,
        CommonModule,
        TranslateModule,
        TextMaskModule,
    ],
    declarations : [
        HeaderComponent,
        FooterComponent,
    ],
    exports:[
        HeaderComponent,
        FooterComponent,
    ],
    providers : [
    ]
})
export class HeaderFooterModule {}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+header-footer/header.footer.module.ts